/*
 * @Author: your name
 * @Date: 2021-06-16 21:09:01
 * @LastEditTime: 2021-06-17 13:58:30
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \e6-module-order-waybill-process\src\e6-module-order-waybill-process\api\businessAlarmSetting.js
 */
import http from "e6-base-core/axios/config";
import { e6ModuleOrderWaybillProcessApi } from "@/config/api";
const { host, E6_MS_TMS_BASE_WEB } = e6ModuleOrderWaybillProcessApi;

//查询公司所有业务报警配置
export function fetchBusinessAlarmSetting() {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/alarmRemindBusinessSet/getAllSet`,
    method: "get"
  });
}
//修改业务报警提醒配置
export function saveBusinessAlarmSettingUpdate(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/alarmRemindBusinessSet/updateAlarmSet`,
    method: "post",
    data
  });
}
